import Vue from 'vue'

export default function ({ app }) {
  Vue.prototype.$locatedLink = function (path, domain) {
    let result = path
    const locale = this.$route.path.split('/')[1]

    if (locale && locale !== app.i18n.defaultLocale && app.i18n.localeCodes.includes(locale)) {
      result = '/' + locale + path
    }

    if (domain) {
      result = domain + result
    }

    return result
  }
}
